/**
 * "Switch to offline mode?" is a SUGGESTION about a working condition, not
 * an event. Once the user has said no, asking again the same day adds
 * nothing but noise — and the detector's hysteresis (three consecutive
 * slow windows, `slowConnectionDetector.ts:13-17`) can flip fast→slow
 * several times in one bad-network session, so a dismissal that lived in
 * component state re-armed itself over and over.
 *
 * Storage is deliberately raw `localStorage` rather than a store: the
 * value has to outlive a reload, and nothing else reads it.
 */
export const SLOW_PROMPT_SNOOZE_MS = 24 * 60 * 60 * 1000

export const SLOW_PROMPT_SNOOZE_KEY = 'slowConnectionPromptSnoozedUntil'

export function isSnoozed(now: number, snoozedUntil: number | null): boolean {
  return snoozedUntil !== null && snoozedUntil > now
}

export function readSnoozedUntil(): number | null {
  try {
    const raw = localStorage.getItem(SLOW_PROMPT_SNOOZE_KEY)
    if (!raw) return null
    const parsed = Number(raw)
    return Number.isFinite(parsed) ? parsed : null
  } catch {
    return null
  }
}

export function writeSnoozedUntil(until: number): void {
  try {
    localStorage.setItem(SLOW_PROMPT_SNOOZE_KEY, String(until))
  } catch {
    // localStorage unavailable — the prompt simply reverts to
    // session-scoped dismissal, which is the old behaviour.
  }
}
